// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2DMEk","text":"text-2TaG8"};